import { Grid } from '@mui/material';
import { UsersGrid } from '../Components/UsersGrid';

export const Users = () => {
    return (
        <Grid container height="100%" justifyContent="center">
            <Grid item sx={{ marginTop: '20px' }} xs={10}>
                <UsersGrid />
            </Grid>
        </Grid>
    );
};
